import classNames from 'classnames';
import PropTypes from 'prop-types'
import T from 'i18n-react';
import './section.css'
import { connect } from 'react-redux';

const WorkflowSection = (props) => (
    <div className={classNames('wf-section-container', 'wf-section-container-WF', { 'wf-section-alternate': props.isAlternate }, props.ticketType.toLowerCase())} >
        <div>
            {!props.hideHeader && <div className={classNames('wf-section-title', 'wf-section-title-WF', {'wf-section-title-WF-payment-filed': props.section === 'payment' || props.section === 'filed'})}>
                <div>
                    {T.translate(props.titleKey, props.titleKeyProps)}
                </div>
            </div>}
            <div className={classNames('wf-section-top-link', { 'wf-section-hide': props.topLinkKey })}
                onClick={props.topLinkClick} >
                {T.translate(props.topLinkKey || '')}
            </div>
        </div>
        {props.children}
    </div>
);

WorkflowSection.propTypes = {
    isAlternate: PropTypes.bool,
    canClose: PropTypes.bool.isRequired,
    titleKey: PropTypes.string.isRequired,
    titleKeyProps: PropTypes.object,
    topLinkKey: PropTypes.string,
    topLinkClick: PropTypes.func,
    children: PropTypes.node,
    onClose: PropTypes.func,
    ticketType: PropTypes.string
};

const mapStateToProps = state => ({
    lang: state.layout.lang
});

export default connect(mapStateToProps)(WorkflowSection);